import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    splideInstance: null,
    currentSlideIndex: 0,

    init: function() {
      if ( $( '.interactive-infographic__splide' ).length ) {
        this.createSlider();
        this.setupEventHandlers();
        this.setupMediaQuery();
      }
    },

    createSlider: function() {
      // Save current slide index before destroying
      if ( this.splideInstance ) {
        this.currentSlideIndex = this.splideInstance.index || 0;
        this.splideInstance.destroy();
        this.splideInstance = null;
      }

      if ( window.innerWidth > 1024 ) {
        this.splideInstance = new Splide( '.interactive-infographic__splide', {
          type: 'fade',
          drag: false,
          perPage: 1,
          perMove: 1,
          pagination: false,
          arrows: false,
          speed: 800,
          gap: '20px',
          breakpoints: {
            1024: {
              destroy: true,
            },
          },
        } );
      } else {
        this.splideInstance = new Splide( '.interactive-infographic__splide', {
          type: 'slide',
          drag: true,
          perPage: 1,
          perMove: 1,
          pagination: false,
          autoWidth: true,
          arrows: false,
          padding: '80px',
          speed: 800,
          gap: '20px',
          mediaQuery: 'min',
          breakpoints: {
            1024: {
              destroy: false,
            },
          },
        } );
      }

      this.splideInstance.mount();
    },

    setupEventHandlers: function() {
      const component = this;

      $( '.interactive-infographic__trigger' ).off( 'click' );

      const currentIndex = component.currentSlideIndex || 0;
      $( '.interactive-infographic__trigger, .svg-diagram path' ).removeClass( 'is-active' );

      // Update button active state (only on desktop)
      if ( window.innerWidth > 1024 ) {
        const $trigger = $( `.interactive-infographic__trigger[data-splide="${currentIndex}"]` );
        if ( $trigger.length ) {
          $trigger.addClass( 'is-active' );
        } else {
          // Fallback to first button if no match
          $( '.interactive-info__button-wrapper:first-of-type .interactive-infographic__trigger' ).addClass( 'is-active' );
        }
      }

      // Update SVG diagram path active state
      const $trigger = $( `.interactive-infographic__trigger[data-splide="${currentIndex}"]` );
      const diagramTarget = $trigger.data( 'target' );
      if ( diagramTarget ) {
        $( diagramTarget ).addClass( 'is-active' );
      }

      // Button click handlers (buttons are hidden on mobile)
      $( '.interactive-infographic__trigger' ).on( 'click', function() {
        if ( $( this ).hasClass( 'is-active' ) ) return;
        const goToSplide = $( this ).data( 'splide' );
        $( '.interactive-infographic__trigger' ).removeClass( 'is-active' );
        component.splideInstance.go( goToSplide );
        $( this ).addClass( 'is-active' );
      } );

      // Handle slide changes - update buttons and SVG diagram paths
      if ( component.splideInstance ) {
        component.splideInstance.on( 'move', function( newIndex, prevIndex, destIndex ) {
          // console.log( 'move', newIndex, prevIndex, destIndex );

          component.currentSlideIndex = destIndex;

          $( '.interactive-infographic__trigger, .svg-diagram path' ).removeClass( 'is-active' );

          // Update button active state (only on desktop)
          if ( window.innerWidth > 1024 ) {
            $( `.interactive-infographic__trigger[data-splide="${destIndex}"]` ).addClass( 'is-active' );
          }

          // Update SVG diagram path active state (both desktop and mobile)
          const diagramTarget = $( `.interactive-infographic__trigger[data-splide="${destIndex}"]` ).data( 'target' );
          if ( diagramTarget ) {
            $( diagramTarget ).addClass( 'is-active' );
          }
        } );
      }

      if ( component.currentSlideIndex > 0 && component.splideInstance ) {
        setTimeout( function() {
          component.splideInstance.go( component.currentSlideIndex );
        }, 0 );
      }
    },

    setupMediaQuery: function() {
      const component = this;
      const mediaQuery = window.matchMedia( '(max-width: 1024px)' );

      mediaQuery.addEventListener( 'change', function( e ) {
        component.createSlider();
        component.setupEventHandlers();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'interactive-infographic', COMPONENT );
} )( app );
